import React from "react"
import { Link } from "gatsby"
import styles from "../../styles/global.module.scss"
import BackgroundImage from "gatsby-background-image"
import ConvertSlug from "../../helpers/convertSlug"

const RemodelingBox = props => {
  const { service, slug } = props
  let featuredImage
  if (service.featuredImage) {
    featuredImage = service.featuredImage.childImageSharp.fluid
  }
  return (
    <Link className={styles.remodelingItem} to={slug}>
      <div>
        {featuredImage ? (
          <BackgroundImage
            fluid={featuredImage}
            className={styles.remodelingImage}
          />
        ) : null}
      </div>
      <div className={styles.remodelingItemContent}>
        <h1>{service.name}</h1>
        <p>{service.description}</p>
      </div>
      <div className={styles.remodelingViewService}>
        <span>{`View ${service.name} Remodeling`}</span>
      </div>
    </Link>
  )
}

export default function RemodelingServices(props) {
  const { services, page_id } = props
  return (
    <div id={styles.remodelingList} className={styles.flexWrapper}>
      {services.map((item, i) => {
        const service = item.node.frontmatter
        let slug = ConvertSlug(page_id, item.node.fields.slug, service.name)
        return <RemodelingBox service={service} slug={slug} key={i} />
      })}
    </div>
  )
}
